<template>
  <div class="right_col" role="main" style="min-height: 1vh !important">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('orderPage.categoryList') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <alert
            :title="alertTitle"
            :success-message="$t('common.isSuccess')"
            :error-message="$t('common.isFailure')"
            :alerts="alerts"
            :errors="errors"
            :display="alertDisplay"
            @closeAlert="closeAlert"
          />
          <div class="text-right">
            <router-link to="/order/category/create" class="btn btn-primary">{{
              $t('common.create')
            }}</router-link>
            <a
              :href="csvURL"
              :download="csvFileName"
              @click="csvDownLoad"
              class="btn btn-default"
              >{{ $t('common.csvDownload') }}</a
            >
          </div>
          <div
            id="datatable_wrapper"
            class="dataTables_wrapper form-inline dt-bootstrap no-footer"
          >
            <draggable-table
              :display-items="allItems"
              :column-titles="tableHeaderColumns"
              @buttonClickEvent="buttonClickEvent"
              @reflectChange="reflectChange"
            />
          </div>
          <div class="text-right">
            <button
              id="btn-submit"
              @click="saveSortOrder()"
              class="btn btn-primary"
            >
              {{ $t('common.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import DraggableTable from '@/components/common/table/DraggableTable'
import { mapGetters } from 'vuex'
import alert from '@/mixin/alert'
import CategoryRequest from '@/http/CategoryRequest'
import Papa from 'papaparse'

export default {
  components: {
    Alert,
    DraggableTable,
  },
  mixins: [alert],
  data() {
    return {
      allItems: [],
      tableHeaderColumns: [
        'ID',
        this.$t('common.categoryName'),
        this.$t('common.edit'),
        this.$t('common.delete'),
      ],
      csvURL: '',
      csvFileName: '',
    }
  },
  computed: {
    ...mapGetters({
      fetchedData: 'category/getCategories',
      language: 'settings/getLanguage',
    }),
    defaultLanguage() {
      return process.env.VUE_APP_LANG
    },
  },
  watch: {
    fetchedData: function(newFetchedData) {
      const data = newFetchedData
      this.allItems = data.list.map((item) => {
        return [
          item.categoryCode,
          item.names[this.language] || item.names[this.defaultLanguage],
          { type: 'edit', id: item.categoryCode },
          { type: 'destroy', id: item.categoryCode },
        ]
      })
    },
    language() {
      this.$store.dispatch('category/getCategories', { master: 1 })
    },
  },
  mounted() {
    let params = {}
    if (this.$route.params.succeeded === true) {
      this.alertTitle = this.$route.params.title
      this.openSuccessAlert()
      params = { master: 1 }
    }

    this.$store.dispatch('category/getCategories', params)
  },
  methods: {
    buttonClickEvent: function(type, id) {
      if (type === 'edit') {
        this.edit(id)
      } else if (type === 'destroy') {
        this.destroy(id)
      }
    },
    // 編集
    edit: function(id) {
      this.$router.push({ name: 'categoryEdit', params: { id: id } })
    },
    // 削除
    destroy: function(id) {
      const category = this.allItems.filter((item) => item[0] === id)
      if (
        !window.confirm(
          `${this.$t('orderPage.categoryDeletionConfirmationBefore')}『${
            category[0][1]
          }』${this.$t('orderPage.categoryDeletionConfirmationAfter')}`
        )
      ) {
        return
      }

      const request = new CategoryRequest()
      request
        .delete(id)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
        })
        .finally(() => {
          this.alertTitle = `${this.$t('orderPage.deleteCategoryBefore')}『${
            category[0][1]
          }』${this.$t('orderPage.deleteCategoryAfter')}`
          const params = { master: 1 }
          this.$store.dispatch('category/getCategories', params)
        })
    },
    // 並び順の保存
    saveSortOrder: function() {
      const order = this.allItems.map((item) => Number(item[0])) // item[0] === categoryCode
      const params = {
        list: order,
      }

      const request = new CategoryRequest()
      request
        .changeSortOrder(params)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
        })
        .finally(() => {
          this.alertTitle = this.$t('orderPage.changeCategoryDisplayOrder')
        })
    },
    // propsは一方通行なので、子コンポーネントで変更された並び順をこちらのthis.allItemsにも反映させる
    reflectChange: function(items) {
      this.allItems = items
    },
    csvDownLoad: function() {
      const content = []
      const headerColumns = this.tableHeaderColumns.concat()
      const tempDisplayItems = this.allItems.concat()
      headerColumns.splice(2, 4)
      content.push(headerColumns)
      tempDisplayItems.forEach((item) => {
        const tempItem = item.concat()
        tempItem.splice(2, 4)
        content.push(tempItem)
      })
      const config = {
        delimiter: ',',
        header: true,
        newline: '\r\n',
      }
      // 区切り文字へ変換
      const delimiterString = Papa.unparse(content, config)
      // blobへの変換
      const blob = new Blob([delimiterString], { type: 'text/csv' })
      this.csvFileName = 'categorylist'
      this.csvURL = (window.URL || window.webkitURL).createObjectURL(blob)
    },
  },
}
</script>
